import { LalSegmentFields, type LalSegmentFormState } from '@openx/types/segments.ts';
import type { I18nTranslate } from '@openx/types/translations.ts';

export const getLalSeedName = (name: string | undefined, t: I18nTranslate): string => {
  const trimmedName = name?.trim();

  return trimmedName ? t(`Seed of ${trimmedName}`) : t('Seed of...');
};

export const getLalSegmentsFormDefaultValues = (
  initialValues: Partial<LalSegmentFormState>,
  t: I18nTranslate
): Partial<LalSegmentFormState> => {
  const seeds = initialValues[LalSegmentFields.SEEDS] ?? [];

  return {
    ...initialValues,
    [LalSegmentFields.SEED_NAME]: getLalSeedName(initialValues[LalSegmentFields.NAME], t),
    [LalSegmentFields.ESTIMATED_REACH]:
      seeds.length === 1 ? seeds[0].reach : (initialValues[LalSegmentFields.ESTIMATED_REACH] ?? 0),
  };
};
